import axios from 'axios';

const state = {
    rscodes: [],
    rscodeLists: [],
    rows: 1,
    meta: {},
    perPage: 10,
};

const getters = {
    rscodes: state =>{
        return state.rscodes;
    },
    rscodeLists: state =>{
        return state.rscodeLists;
    },
    rows: state => {
        return state.rows;
    },
    meta: state => {
        return state.meta;
    },
    perPage: state => {
        return state.perPage;
    },
};

const actions = {
    getRSCodes({commit, dispatch}, filter){
        dispatch('Settings/loading', true,{root:true});
        try {
            axios
                .get(`/admin/rscodes?page=${filter.currentPage}&sortBy=${filter.sortBy}&sortOrder=${filter.sortOrder}`)
                .then((res) => {

                    commit('setRSCodes', res.data.data);
                    commit('setRows', Math.ceil(
                        res.data.meta.total / res.data.meta.per_page
                    ))
                    commit('setMeta', res.data.meta)
                    commit('setPerPage', parseInt(res.data.meta.per_page))
                    dispatch('Settings/loading', false, { root: true });
                })
                .catch((err) => {
                    console.log(err);
                    dispatch('Settings/loading', false,{root:true});
                });
        } catch (err) {
            console.log(err);
            dispatch('Settings/loading', false,{root:true});
        }

    },
    getRSCodeLists({commit, dispatch}, currentPage){
        dispatch('Settings/loading', true,{root:true});
        try {
            axios
                .get(`/admin/rscodes/lists?page=${currentPage  ? currentPage : '1'}`)
                .then((res) => {

                    commit('setRSCodeLists', res.data.data);
                    dispatch('Settings/loading', false, { root: true });
                })
                .catch((err) => {
                    console.log(err);
                    dispatch('Settings/loading', false,{root:true});
                });
        } catch (err) {
            console.log(err);
            dispatch('Settings/loading', false,{root:true});
        }

    },
    storeRSCode({commit}, payload){
        return axios
            .post(`/admin/rscodes`, payload)
            .then((res) => {
                commit('updateRSCodesList', res.data.data);
            });
    },

    updateRSCode({commit}, user){
        return axios
            .put(`/admin/rscodes/${user.id}`, user)
            .then((res) => {
                commit('updateEditedRSCode', res.data.data);
            });
    },
    destroy({ commit }, id) {
        return axios.delete(`/admin/rscodes/${id}`).then((res) => {
            commit("DELETE_NOTICE", id);
            return res;
        });
    },
};

const mutations = {
    setRSCodes(state, rscodes){
        state.rscodes = rscodes;
    },
    setRSCodeLists(state, rscodes){
        state.rscodeLists = rscodes;
    },
    updateRSCodesList(state, user){
        state.rscodes.unshift(user);
    },
    updateEditedRSCode(state, user){
        state.rscodes.map((item,index)=>{
            if(item.id == user.id){
                state.rscodes[index] = user;
            }
        });
    },
    DELETE_NOTICE(state, id) {
        const i = state.rscodes.map((item) => item.id).indexOf(id);
        state.rscodes.splice(i, 1);
    },
    setRows(state, rows) {
        state.rows = rows;
    },
    setMeta(state, meta) {
        state.meta = meta;
    },
    setPerPage(state, perPage) {
        state.perPage = perPage;
    },
};

export default {
    namespaced:true,
    state,
    getters,
    actions,
    mutations
}
